import type { ApiAreaOfFocus } from '#/api/types/ApiAreaOfFocus';
import { DetailsListColumn } from '#/components/DetailsList/DetailsListColumn';
import { DetailsListRow } from '#/components/DetailsList/DetailsListRow';
import { DetailsListGroup } from '#/components/DetailsList/Group/DetailsListGroup';
import { DetailsListItem } from '#/components/DetailsList/Item/DetailsListItem';
import { useI18n } from '#/i18n/hooks/useI18n';
import { ViewUserProfilePageContentSection } from '#/modules/userProfile/components/ViewUserProfilePageContentSection';
import { ViewUserProfilePageContentCenterDetailsLink } from '#/modules/userProfile/pages/view/ViewUserProfilePage.styled';
import { AREAS_OF_FOCUS } from '#/utils/constants/general/areasOfFocus';
import { getIconNameFromLink } from '#/utils/social/iconNameBySocialNetwork';
import { formatToHumanReadableUrl } from '#/utils/string/formatToHumanReadableLink/formatToHumanReadableUrl';

type Props = {
  areasOfFocus: ApiAreaOfFocus[];
  links: string[];
};

export function ViewUserProfilePageContentSectionDetails({
  areasOfFocus,
  links,
}: Props) {
  const { i18n } = useI18n();

  return (
    <ViewUserProfilePageContentSection
      title={i18n('Details')}
      qaId="view-user-profile-page-content-section-details"
    >
      <DetailsListRow>
        {areasOfFocus.length > 0 && (
          <DetailsListColumn>
            <DetailsListGroup title={i18n('Cause Areas')}>
              <DetailsListItem
                iconName="globe"
                value={
                  <span data-qa-id="view-user-profile-page-areas-of-focus">
                    {areasOfFocus
                      .map((areaOfFocus) => AREAS_OF_FOCUS(i18n)[areaOfFocus])
                      .join(', ')}
                  </span>
                }
              />
            </DetailsListGroup>
          </DetailsListColumn>
        )}

        {links.length > 0 && (
          <DetailsListColumn>
            <DetailsListGroup title={i18n('Links')}>
              {links.map((link, index) => (
                <DetailsListItem
                  // oxlint-disable-next-line react/no-array-index-key
                  key={index}
                  iconName={getIconNameFromLink(link)}
                  value={
                    <ViewUserProfilePageContentCenterDetailsLink
                      href={link}
                      noIndex
                      qaId="view-user-profile-page-link"
                    >
                      {formatToHumanReadableUrl(link)}
                    </ViewUserProfilePageContentCenterDetailsLink>
                  }
                />
              ))}
            </DetailsListGroup>
          </DetailsListColumn>
        )}
      </DetailsListRow>
    </ViewUserProfilePageContentSection>
  );
}
